import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class ColorGroupService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 3846
     * @datataskName sp_ws_p2_product_colorgrp_list
     * @param params prod id to get color groups for.
     * @returns promise containing list of color groups for the product.
     */
    public getProductColorGroups(params: GetColorGroupsParams): Promise<ProductColorGroupItem[]> {
        return this.datatask.Post(3846, params);
    }
}

export interface GetColorGroupsParams {
    prod_id: string;
}

export interface ProductColorGroupItem {
    item_id: string;
    item_name: string;
    orderby: string;
}
